<div class="design-grid-container" [ngStyle]="gridContainerStyle">
    <div class="grid" [ngStyle]="gridStyle">
        <ng-container *ngFor="let row of grid; let i = index">
            <div class="row">
                <button *ngFor="let button of row; let j = index" (click)="onButtonClick(i, j)" [disabled]="!getButtonClickable(i,j)" [ngClass]="getButtonClass(button)" [ngStyle]="getButtonImage(i, j)"></button>
            </div>
        </ng-container>
    </div>    
</div>
